<template>
  <div class="home-navbar">
    <div class="flex-horizontal" style="height: 100%; align-items: center;">
      <home-tabs-management />
      <back-to-workspace-selection />
      <home-layout-selection />
      <fullscreen />
    </div>
  </div>
</template>

<script>
import { mixin as clickaway } from "vue-clickaway";
import UserButton from "../../User/Navbar/UserButton";
import UserWindow from "@/components/User/Navbar/UserWindow/UserWindow";
import HomeLayoutSelection from "./LayoutSelection";
import BackToWorkspaceSelection from "./BackToWorkspaceSelection";
import HomeTabsManagement from "./TabsManagement";
import Fullscreen from "@/components/Home/NavBar/Fullscreen";

export default {
  name: "HomeNavBar",

  mixins: [clickaway],

  components: {
    Fullscreen,
    HomeTabsManagement,
    BackToWorkspaceSelection,
    HomeLayoutSelection,
    UserButton,
    UserWindow
  }
};
</script>

<style scoped>
.home-navbar {
  background: white;
  position: absolute;
  width: calc(100vw - 50px);
  top: 0;
  right: 0;
  height: 50px;
  z-index: 201;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  box-shadow: 4px 4px 4px 0px rgba(0, 0, 0, 0.25);
}
.flex-horizontal-right {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: flex-end;
}

#badge >>> .v-badge__badge {
  top: 8px !important;
  left: 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/NavBar/NavBar.vue